import { CanActivate } from '@angular/router';

export class RootAuthGuard implements CanActivate {

  public canActivate() {
    return true;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/guards/root-auth.guard.ts